import { FlagSummaryButton } from '@modules/feedback/components/FeedbackSummary/FlagSummaryButton';
import { ChatRounded, SummarizeRounded } from '@mui/icons-material';
import { Chip, Stack, Typography } from '@mui/material';
import { RecordSummary, SummaryFlag } from 'generated/graphql';
import { ReactNode } from 'react';
import { UUID } from 'v2/core/entities/uuid';

interface SummaryOrFeedbackLabelProps {
  feedbackID: UUID;
  label: string | ReactNode;
  summary?: RecordSummary;
  isSummaryView: boolean;
  isAudioRecord?: boolean;
  bgVariant?: 'default' | 'transparent';
  padding?: number;
  shouldShowFeedbackSummaryActions?: boolean;
}

export const SummaryOrFeedbackLabel = ({
  feedbackID,
  label,
  summary,
  isSummaryView,
  isAudioRecord = false,
  bgVariant = 'default',
  padding = 1,
  shouldShowFeedbackSummaryActions = true,
}: SummaryOrFeedbackLabelProps) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Chip
        label={
          typeof label === 'string' ? (
            <Typography variant="body1">{label}</Typography>
          ) : (
            label
          )
        }
        icon={
          isSummaryView ? (
            <SummarizeRounded fontSize="small" />
          ) : (
            <ChatRounded fontSize="small" />
          )
        }
        sx={{
          backgroundColor:
            bgVariant === 'transparent' ? 'transparent' : undefined,
          p: padding,
          borderRadius: 1.5,
          height: 'fit-content',
          '.MuiChip-icon': {
            color: isSummaryView ? 'info.main' : 'feedback.label',
          },
          '&. MuiChip-label': {
            display: 'block',
          },
        }}
      />
      {!isAudioRecord && shouldShowFeedbackSummaryActions && (
        <Stack
          sx={{
            position: 'absolute',
            right: 0,
            zIndex: 4,
            pr: 1,
          }}
        >
          <FlagSummaryButton
            feedbackID={feedbackID}
            initialFlag={summary?.flag}
            summaryFlagType={SummaryFlag.Incorrect}
          />
        </Stack>
      )}
    </Stack>
  );
};
